import { useEffect, useRef } from "react";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";

type Props = {
    onScanSuccess: (decodedText: string) => void;
    onClose: () => void;
};

const QRCodeScanner = ({ onScanSuccess, onClose }: Props) => {
    const qrCode = useRef<Html5Qrcode | null>(null);
    const id = "qr-reader";

    useEffect(() => {
        if (!qrCode.current?.getState()) {
            qrCode.current = new Html5Qrcode(id);

            const cameraIdOrConfig = { facingMode: "environment" };
            const configuration = {
                fps: 10,
                qrbox: { width: 250, height: 250 },
            };
            const qrCodeSuccessCallback = async (decodedText: string) => {
                onScanSuccess(decodedText);
                try {
                    await qrCode.current?.stop();
                    onClose();
                } catch (e) {
                    console.warn(e);
                }
            };
            const qrCodeErrorCallback = (error: string) => {
                console.warn("QRCodeScanner", error);
            };

            qrCode.current.start(
                cameraIdOrConfig,
                configuration,
                qrCodeSuccessCallback,
                qrCodeErrorCallback,
            );
        }

        return () => {
            if (
                qrCode.current &&
                (qrCode.current.getState() ===
                    Html5QrcodeScannerState.SCANNING ||
                    qrCode.current.getState() ===
                        Html5QrcodeScannerState.PAUSED)
            ) {
                qrCode.current.stop().catch(console.warn);
            }
        };
    }, [onScanSuccess, onClose]);

    return <div id={id}></div>;
};

export default QRCodeScanner;
